module.exports = __webpack_public_path__ + "img/main-768.231288fc.png";